export const getHomepageLogoutOptions = () => ({
  redirectUrl: window.location.origin,
});
